import { Check } from "lucide-react";

/**
 * Shared chip / pill selector used across wizard steps for multiselect
 * values (goals, tone, formats). Honors the `max` cap and visually dims
 * disabled options once the cap is hit.
 */
export function Chip({
    label,
    selected,
    disabled,
    onToggle,
    testId,
    withCheck = true,
}) {
    return (
        <button
            type="button"
            onClick={onToggle}
            disabled={disabled && !selected}
            data-testid={testId}
            data-selected={selected ? "true" : "false"}
            className={[
                "group inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-all duration-200",
                selected
                    ? "border-[#00F5D4] bg-[#00F5D4]/10 text-[#00F5D4] shadow-[0_0_12px_rgba(0,245,212,0.2)]"
                    : disabled
                      ? "cursor-not-allowed border-[#1F2A40] bg-[#111726] text-[#8A93A6] opacity-50"
                      : "border-[#1F2A40] bg-[#111726] text-[#E8ECF5] hover:border-[#00F5D4]/50 hover:text-[#00F5D4]",
            ].join(" ")}
        >
            {withCheck && selected && (
                <Check className="h-3 w-3" strokeWidth={3} />
            )}
            <span>{label}</span>
        </button>
    );
}

/**
 * Big radio-style chip used for duration selection in Step 2.
 */
export function RadioChip({ label, caption, selected, onSelect, testId }) {
    return (
        <button
            type="button"
            onClick={onSelect}
            data-testid={testId}
            data-selected={selected ? "true" : "false"}
            className={[
                "flex min-w-[112px] flex-col items-center gap-1 rounded-xl border px-5 py-3 text-sm font-semibold transition-all duration-200",
                selected
                    ? "border-[#2F58CD] bg-gradient-to-b from-[#2F58CD]/15 to-[#111726] text-[#E8ECF5] shadow-[0_0_22px_rgba(47,88,205,0.3)]"
                    : "border-[#1F2A40] bg-[#111726] text-[#E8ECF5] hover:border-[#00F5D4]/50",
            ].join(" ")}
        >
            <span className="text-base">{label}</span>
            {caption && (
                <span className="font-mono text-[9px] uppercase tracking-[0.22em] text-[#8A93A6]">
                    {caption}
                </span>
            )}
        </button>
    );
}
